












































import { Component, Vue, Prop } from 'vue-property-decorator';
import { UtilService, userSvc } from '@/services';
import { Response } from '@/types';
import { Notification } from 'element-ui';

@Component({
  name: 'join-form'
})
export default class JoinForm extends Vue {
  private email: string = '';
  private emailState: boolean | null = null;
  private passwordConfirm: string = '';
  private passwordConfirmState: boolean | null = null;
  private password: string = '';
  private passwordState: boolean | null = null;
  private isLoading: boolean = false;
  @Prop({ type: String, required: true })
  token!: string;

  /**
   * onSubmit
   */
  async onSubmit(e: Event) {
    e.preventDefault();

    if (this.validate()) {
      this.isLoading = true;
      try {
        const resp: Response = await this.$store.dispatch('join', {
          email: this.email,
          password: this.password,
          token: this.token
        });
        Notification.info(resp.message);
      } catch (e) {
        this.isLoading = false;
      }
      this.isLoading = false;
    } else {
      return false;
    }
  }

  validate() {
    let pass = true;
    if (UtilService.validateEmail(this.email)) {
      this.emailState = true;

      if (this.password === this.passwordConfirm) {
        if (this.password.length < 8) {
          pass = false;
          this.passwordState = false;
          this.passwordConfirmState = false;
          this.$message.error('Your password is too short. minimum is 8');
        }
      } else {
        pass = false;
        this.passwordState = false;
        this.passwordConfirmState = false;
        this.$message.error('Your passwords are not match.');
      }
    } else {
      pass = false;
      this.emailState = false;
      this.$message.error('Invalid email');
    }
    return pass;
  }
}
